export class DropdownModel {

  key: string;
  value: string;
  iconURL: string;
  bgColor: string;

  constructor(key: string = null, value: string = null, iconURL = null) {
    this.key = key;
    this.value = value;
    this.iconURL = iconURL;
  }

  static generateFromKey(key: string, valuePrefix: string = ''): DropdownModel {

    const obj = new DropdownModel();
    obj.key = key;
    obj.value = `${valuePrefix}${key}`;

    return obj;

  }

  static generateFromKeys(keys: string[], includeNone = false, valuePrefix: string = ''): DropdownModel[] {

    const list = [];

    if (includeNone) {
      list.push(
        new DropdownModel(null, 'reusable.none', null)
      );
    }

    for (const key of keys) {
      list.push( this.generateFromKey(key, valuePrefix) );
    }

    return list;

  }

}
